<template>
  <custom-multiselect v-model="selected" :list="options" :allowEmpty="false" :disabled="disabled">
    <template v-slot:block="props">
      <span>{{ props.value.name }}</span>
    </template>
    <template v-slot:list="props">
      <span>{{ props.value.name }}</span>
    </template>
  </custom-multiselect>
</template>
<script>
// Group picker: v-model is a group id, null means "without a group".
export default {
  name: "GroupSelect",
  props: {
    value: {
      type: String,
      default: null,
    },
    groups: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    options() {
      return [{ id: null, name: this.$t("satellites.groups.none") }, ...this.groups.map((group) => ({ id: group.id, name: group.name }))];
    },
    selected: {
      get() {
        return this.options.find((option) => option.id === this.value) || this.options[0];
      },
      set(option) {
        this.$emit("input", option.id);
      },
    },
  },
};
</script>
